import { forwardRef, createElement } from 'react';
import cn from 'classnames';
import { Icon } from '../Icon/Icon.js';
import { getButtonClasses, getAppearanceClasses, createButton } from './util.js';

const Button = /*#__PURE__*/forwardRef(function Button(props, ref) {
  const {
    fluid,
    ...otherProps
  } = props;
  const className = cn(getButtonClasses(), getAppearanceClasses(otherProps.appearance), 'rounded px-3', {
    'cursor-not-allowed opacity-50': props.disabled,
    'focus:yt-focus active:focus:yt-focus': !props.disabled,
    'w-full': fluid
  }, props.className);
  let children = otherProps.children; // add a chevron icon to menu buttons

  if (typeof otherProps.menu === 'function') {
    children = Array.isArray(children) ? [...children, createElement(Icon, {
      key: "chevron-down",
      name: "chevron-down"
    })] : [children, createElement(Icon, {
      key: "chevron-down",
      name: "chevron-down"
    })];
  }

  return createButton({ ...otherProps,
    children,
    'data-taco': 'button'
  }, className, ref);
});

export { Button };
//# sourceMappingURL=Button.js.map
